import { CREATE_SKETCH, DELETE_SKETCH, CLEAR_SKETCH, OPEN_SKETCH_MODAL, CLOSE_SKETCH_MODAL } from '../types'

const initialState = {
  isModalOpen: false,
  sketches: [],
}

const sketchReducer = (state = initialState, action) => {
  let index
  switch (action.type) {
    case CREATE_SKETCH:
      return {
        ...state,
        isModalOpen: false,
        sketches: [action.payload, ...state.sketches],
      }

    case DELETE_SKETCH:
      index = state.sketches.findIndex((sketch) => sketch === action.payload)
      state.sketches.splice(index, 1)
      return {
        ...state,
      }

    case CLEAR_SKETCH:
      return initialState

    case OPEN_SKETCH_MODAL:
      return {
        ...state,
        isModalOpen: true,
      }

    case CLOSE_SKETCH_MODAL:
      return {
        ...state,
        isModalOpen: false,
      }
    default:
      return state
  }
}

export default sketchReducer
